import { render, staticRenderFns } from "./BowFilters.vue?vue&type=template&id=0feaa07a&"
import script from "./BowFilters.vue?vue&type=script&lang=js&"
export * from "./BowFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowToggle: require('/workspace/components/atoms/BowToggle/BowToggle.vue').default,BowSelect: require('/workspace/components/atoms/BowSelect/BowSelect.vue').default,BowText: require('/workspace/components/atoms/BowText/BowText.vue').default,BowButton: require('/workspace/components/atoms/BowButton/BowButton.vue').default})
